import { bookingInquiryApis, InquiryCancelDetailBody } from '@apis/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const useBookingInquiryCancelDetail = (d2dNo: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: InquiryCancelDetailBody) => {
      const response = await bookingInquiryApis.patch('/booking-inquiry/cancel-detail/{d2dNo}/', {
        path: { d2dNo },
        body,
      });

      // if (response[400]) {
      //   throw new MessageError(response[400].message);
      // }

      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/booking-inquiry/']);
        queryClient.invalidateQueries(['/dashboard/booking-inquiry/']);
        queryClient.invalidateQueries([`/booking-inquiry/${d2dNo}/`]);
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2dNo}/`]);
      },
    },
  );
};
